import { Alert, AlertTitle } from '@mui/material';

/**
 * Fallback strings used until `BrandingConfig.copy.apiUnavailable` lands.
 *
 * **Branding gap.** Requirement 8.2 + 8.4 reference
 * `BrandingConfig.copy.apiUnavailable.title` and `.body`; the
 * `BrandingTokens` shape published by `models/src/branding-config.ts`
 * does not yet declare those keys (gated on TODO-013 — brand assets).
 * The strings below are the default English values from Requirement
 * 8.4 and are replaced with a
 * `brandingFixture.copy.apiUnavailable.{title,body}` read once the
 * contract surface adds the keys.
 */
const FALLBACK_TITLE = 'Temporarily unavailable';
const FALLBACK_BODY = 'We could not reach the live content service. Cached content (if any) is shown below.';

/**
 * `<ApiUnavailableBanner>` — rendered above any cached content when a
 * content-bearing API call fails (non-2xx or network error) per
 * Requirement 8.2. Uses MUI `<Alert severity="warning">`.
 *
 * Per Requirement 8.2, the page MUST NOT be blanked: the banner sits
 * above whatever cached content is already on screen. Per Requirement
 * 8.3 this surface and `<EmptyResults>` are mutually exclusive — one
 * is the success-but-empty path, the other is the failure path.
 *
 * _Requirements: Requirement 8.2, R8.12, design §6.2._
 */
export function ApiUnavailableBanner(): JSX.Element {
  return (
    <Alert severity="warning" role="alert">
      <AlertTitle>{FALLBACK_TITLE}</AlertTitle>
      {FALLBACK_BODY}
    </Alert>
  );
}
